<app-titledescription [title]="'Competencias'" [description]="'Aca se muestra el listado de titulos'"></app-titledescription>
<app-button
    text="Agregar Competencia"
    tooltip="Agregar nueva competencia"
    href="/competencias/create"
    typeButton="button"
></app-button>
@if(dataFetch) {
  <app-table
  [columnsNames]="columnNames"
  [dataFetch]="dataFetch"
  [totalItems]="totalItems"
  (fetchAgain)="fetchData($event.options, $event.ignoreCache)"
  [apiService]="apiService"
  [paginateOptions]="paginateOptions"
  [pageIndex]="pageIndex"
  ></app-table>
}







